import React from 'react';
import PropTypes from 'prop-types';

import styles from './AccountFinderHeader.css';

const AccountFinderHeader = ({ title }) => (
    <div className="header-container">
        <div className="af-header-wrapper">
            <h1 className="account-finder-title">{title}</h1>
        </div>
        <style jsx>{styles}</style>
    </div>
);

AccountFinderHeader.defaultProps = {
    title: "Choose the new account type you'd like to open"
};

AccountFinderHeader.propTypes = {
    title: PropTypes.string
};

export default AccountFinderHeader;
